/**
 * @vuepress
 * ---
 * title: Advance by purchase
 * ---
 */
import Transformer from "@/transformers/transformer";
import moment from "moment";

/**
 * @class advanceTransformer
 * Advance transformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */

const invoiceTransform = ({id, uuid, pdf_file, xml_file}) => {
  return {
    id, uuid,
    PDF: pdf_file,
    XML: xml_file
  }
}

class advanceTransformer extends Transformer {
  /**
   * Transform file to send
   *
   * @param advance to send advance
   *
   * @returns {Object} The transformed advance
   */

  static fetch(advance) {
    return {
      total: advance[0].total,
      ivaTotal: advance[1]["I.V.A"],
      totalWithIVA: advance[2].total_with_iva,
      advances: advance[3].advances.map(
        ({
          percentage,
          user_requesting,
          amount,
          date,
          PDF,
          XML,
          comment,
          id,
          approval_status: approvalStatus,
          advance_type: advanceType,
        }) => {
          return {
            percentage,
            userRequesting: user_requesting,
            amount: parseFloat(amount),
            date: moment(date).locale("es").format("Do MMMM YYYY"),
            pdf: PDF,
            xml: XML,
            comment,
            id,
            advanceType,
          };
        }
      ),
      currentTotal: advance[4].current_total,
      ivaCurrentTotal: advance[5]["I.V.A"],
      currentWithIVA: advance[6].current_total_with_iva,
      invoices: advance[7] ? advance[7].invoices.map((invoice) => invoiceTransform(invoice)) : []
    };
  }
  /**
   * Transform file to send
   *
   * @param advance to send advance
   *
   * @returns {Object} The transformed advance
   */

  static send(advance) {
    const formData = new FormData();
    formData.append("amount", advance.amount);
    if (advance.pdf) {
      formData.append("PDF", advance.pdf);
    }
    if (advance.xml) {
      formData.append("XML", advance.xml);
    }
    formData.append("comment", advance.comment);
    formData.append("advance_type", advance.advance_type);
    return formData;
  }
  /**
   * Transform file to send
   *
   * @param advance to send advance
   *
   * @returns {Object} The transformed advance
   */

  static update(advance) {
    const formData = new FormData();
    if (advance.pdf) {
      formData.append("PDF", advance.pdf);
    }
    if (advance.xml) {
      formData.append("XML", advance.xml);
    }
    return formData;
  }
}

export default advanceTransformer;



// WEBPACK FOOTER //
// ./src/transformers/purchase/advanceByPurchase.js